module.exports = __webpack_public_path__ + "static/media/LSicon.9b0ef868.png";